<div class="progress-loader" [hidden]="!loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ 'COMMON.LoadingText' | labelText }}</span>
  </div>
</div>
